// @ts-nocheck
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

/* Importações de Estilo Terceirizados */
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";

// 🟢 Trava de segurança para anular o erro de 'HTMLElement | null'
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Falha crítica: Elemento DOM 'root' não encontrado.");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);